import {
    Exercise,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
    Tip,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { IllustrationShower } from '../../icons';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData26: ExerciseData = {
    ExerciseView: Module2Exercise6,
    dataKeys: [],
    questions: [],
};

function Module2Exercise6({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="Skift mellem speeder og bremse">
            <LabelDisplay2 class="mt-20">Prøv et koldt bad</LabelDisplay2>
            <LabelBody class="my-10">
                En måde for alvor at mærke vekslen mellem din krops speeder- og
                bremsesystem, er gennem at eksperimentere med kulde og varme. At
                skifte mellem kulde og varme er et konkret redskab til at øge
                din bevidsthed om kroppens speeder- og bremsesystem. Samtidig
                med at du styrker denne skelnen, træner du også din tolerance
                overfor det ubehag, som det kolde vand giver.
            </LabelBody>
            <LabelBody class="mb-10">
                Når vi giver kroppen et chok med det kolde vand, vil kroppen
                tro, at der er grund til panik og vil begynde at aktivere
                speedersystemet. Og når vi er i det varme, behagelige vand, så
                finder vi typisk ro og aktivering af bremsesystemet.
            </LabelBody>
            <LabelBody>
                Hvis du har mod på det, kan du forsøge næste gang du er i bad,
                at skifte fra varmt til koldt vand. Forsøg at blive i det kolde
                vand i minimum 1 minut, og skift så tilbage til det varme vand.
            </LabelBody>
            <IllustrationShower className="mx-auto my-30" />
            <Tip className="mb-30">
                Hvis du har adgang/penge til en sauna, så kan det være et godt
                sted at eksperimentere mellem de to modpoler.
            </Tip>
            <Spacer />
            <SecondaryButton
                onClick={() => {
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    });
                }}
            >
                Afslut øvelsen
            </SecondaryButton>
        </Exercise>
    );
}
